!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("prop-types"), require("@leafygreen-ui/hooks"));else if ("function" == typeof define && define.amd) define(["react", "prop-types", "@leafygreen-ui/hooks"], t);else {
    var r = "object" == typeof exports ? t(require("react"), require("prop-types"), require("@leafygreen-ui/hooks")) : t(e.react, e["prop-types"], e["@leafygreen-ui/hooks"]);

    for (var n in r) {
      ("object" == typeof exports ? exports : e)[n] = r[n];
    }
  }
}("undefined" != typeof self ? self : this, function (e, t, r) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 4);
  }([function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.useUsingKeyboardContext = function () {
      return (0, u.useContext)(s);
    }, t.default = t.NavigationKeyCodes = t.UsingKeyboardContext = void 0;

    var o,
        u = function (e) {
      if (e && e.__esModule) return e;
      if (null === e || "object" !== n(e) && "function" != typeof e) return {
        default: e
      };
      var t = f();
      if (t && t.has(e)) return t.get(e);
      var r = {},
          o = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var u in e) {
        if (Object.prototype.hasOwnProperty.call(e, u)) {
          var i = o ? Object.getOwnPropertyDescriptor(e, u) : null;
          i && (i.get || i.set) ? Object.defineProperty(r, u, i) : r[u] = e[u];
        }
      }

      r.default = e, t && t.set(e, r);
      return r;
    }(r(0)),
        i = (o = r(1)) && o.__esModule ? o : {
      default: o
    },
        a = r(5);

    function f() {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap();
      return f = function f() {
        return e;
      }, e;
    }

    function l(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var r = [],
            n = !0,
            o = !1,
            u = void 0;

        try {
          for (var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          o = !0, u = e;
        } finally {
          try {
            n || null == a.return || a.return();
          } finally {
            if (o) throw u;
          }
        }

        return r;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return c(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(r);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return c(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }

      return n;
    }

    var s = (0, u.createContext)({
      usingKeyboard: !0,
      setUsingKeyboard: function setUsingKeyboard() {}
    });
    t.UsingKeyboardContext = s;
    var d = {
      tab: 9,
      leftArrow: 37,
      upArrow: 38,
      rightArrow: 39,
      downArrow: 40
    };

    function y(e) {
      var t = e.children,
          r = l((0, u.useState)(!1), 2),
          n = r[0],
          o = r[1];
      (0, a.useEventListener)("mousedown", function () {
        return o(!1);
      }, {
        enabled: n
      }), (0, a.useEventListener)("keydown", function (e) {
        var t = e.keyCode;
        Object.values(d).includes(t) && o(!0);
      }, {
        enabled: !n
      });
      var i = (0, u.useMemo)(function () {
        return {
          usingKeyboard: n,
          setUsingKeyboard: o
        };
      }, [n]);
      return u.default.createElement(s.Provider, {
        value: i
      }, t);
    }

    t.NavigationKeyCodes = d, y.displayName = "UsingKeyboardProvider", y.propTypes = {
      children: i.default.node
    };
    var p = y;
    t.default = p;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.useBaseFontSize = function () {
      return (0, u.useContext)(f);
    }, t.default = void 0;

    var o,
        u = function (e) {
      if (e && e.__esModule) return e;
      if (null === e || "object" !== n(e) && "function" != typeof e) return {
        default: e
      };
      var t = a();
      if (t && t.has(e)) return t.get(e);
      var r = {},
          o = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var u in e) {
        if (Object.prototype.hasOwnProperty.call(e, u)) {
          var i = o ? Object.getOwnPropertyDescriptor(e, u) : null;
          i && (i.get || i.set) ? Object.defineProperty(r, u, i) : r[u] = e[u];
        }
      }

      r.default = e, t && t.set(e, r);
      return r;
    }(r(0)),
        i = (o = r(1)) && o.__esModule ? o : {
      default: o
    };

    function a() {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap();
      return a = function a() {
        return e;
      }, e;
    }

    var f = (0, u.createContext)(14);

    function l(e) {
      var t = e.children,
          r = e.baseFontSize,
          n = void 0 === r ? 14 : r;
      return u.default.createElement(f.Provider, {
        value: n
      }, t);
    }

    l.displayName = "TypographyProvider", l.propTypes = {
      children: i.default.node,
      baseFontSize: i.default.number
    };
    var c = l;
    t.default = c;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "useUsingKeyboardContext", {
      enumerable: !0,
      get: function get() {
        return o.useUsingKeyboardContext;
      }
    }), Object.defineProperty(t, "useBaseFontSize", {
      enumerable: !0,
      get: function get() {
        return u.useBaseFontSize;
      }
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function get() {
        return i.default;
      }
    });
    var n,
        o = r(2),
        u = r(3),
        i = (n = r(6)) && n.__esModule ? n : {
      default: n
    };
  }, function (e, t) {
    e.exports = r;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(r(0)),
        o = a(r(1)),
        u = a(r(2)),
        i = a(r(3));

    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function f(e) {
      var t = e.children,
          r = e.baseFontSize;
      return n.default.createElement(u.default, null, n.default.createElement(i.default, {
        baseFontSize: r
      }, t));
    }

    f.displayName = "LeafyGreenProvider", f.propTypes = {
      children: o.default.node
    };
    var l = f;
    t.default = l;
  }]);
});